import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './funcionalidadeNavbar/Navbar';

import { useAuth } from './AuthContext';
import Funcionalidades from './funcionalidadeNavbar/Funcionalidades';
import Inicio from './funcionalidadeNavbar/Inicio'; 
import LoginPage from './funcionalidadeNavbar/LoginPage';
import Contato from './funcionalidadeNavbar/Contato'; 
import Dashboard from './funcionalidadeNavbar/Dashboard';
import PagamentoPage from './pagamento/PagamentoPage';
import ItemsFichaTecnica from "./itemsDaFichaTecnica/ItemsFichaTecnica";
import CadastrarItemsFichaTecnica from './itemsDaFichaTecnica/ItemsFichaTecnica';


import MovimentacaoEstoque from './materiaPrima/MovimentacaoEstoque';
import ConsultaSaldoEstoque from './materiaPrima/ConsultaSaldoEstoque';
import HistoricoMovimentacaoEstoque from './materiaPrima/HistoricoMovimentacaoEstoque';
import CadastroOrdemProducao from './produto/CadastroOrdemProducao';
import InsumosOrdemProducao from './produto/InsumosOrdemProducao';
import ConfigPage from './funcionalidadeNavbar/ConfigPage';
import TesteCalce from './qualidade/TesteCalce';
import TesteCalceDashboard from './qualidade/TesteCalceDashboard';
import TesteCalcePublic from './qualidade/TesteCalcePublic';
import { useKeyboardShortcuts } from './utils/KeyboardShortcuts';

const App = () => {
  const { isAuthenticated } = useAuth();

  // Habilita os atalhos de teclado globalmente
  useKeyboardShortcuts();

  return (
    <div>
      <Router>
        {/* Navbar é renderizada apenas se o usuário não estiver autenticado */}
        {!isAuthenticated && <Navbar />}

        <Routes>
          {/* Página Inicial */}
          <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Inicio />} />

          {/* Páginas acessíveis sem autenticação */}
          <Route path="/loginPage" element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />} />
          <Route path="/contato" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Contato />} />
          <Route path="/pagamento" element={<PagamentoPage />} />

          {/* Rota para o Dashboard (apenas acessível se autenticado) */}
          <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/loginPage" />} />

          {/* Outras rotas públicas podem ser adicionadas aqui */}
          <Route 
            path="/itemsDaFichaTecnica/ItemsFichaTecnica/:idFichaTecnica/:idProduto" 
            element={<ItemsFichaTecnica />} 
        />
        
        <Route 
            path="/itemsDaFichaTecnica/ItemsFichaTecnica/recarregarItemsFicha/:idProduto" 
            element={<ItemsFichaTecnica />} 
        />
        <Route path="/cadastrar-items" element={<CadastrarItemsFichaTecnica />} />

  <Route path="/qualidade/teste-calce/:produtoId" element={<TesteCalce />} />
  <Route path="/qualidade/teste-calce" element={<TesteCalce />} />
  <Route path="/qualidade/avaliar/:id" element={<TesteCalcePublic />} />
  <Route path="/qualidade/dashboard" element={<TesteCalceDashboard />} />

        {/* Configuração de permissões (só visível para administradores) */}
        <Route path="/config" element={isAuthenticated ? <ConfigPage /> : <Navigate to="/loginPage" />} />
        {/* PCP - Estoque e Ordem de Produção */}
        <Route path="/estoque/movimentacao" element={isAuthenticated ? <MovimentacaoEstoque /> : <Navigate to="/loginPage" />} />
        <Route path="/estoque/saldo" element={isAuthenticated ? <ConsultaSaldoEstoque /> : <Navigate to="/loginPage" />} />
        <Route path="/estoque/historico" element={isAuthenticated ? <HistoricoMovimentacaoEstoque /> : <Navigate to="/loginPage" />} />
        <Route path="/ordem/cadastro" element={isAuthenticated ? <CadastroOrdemProducao /> : <Navigate to="/loginPage" />} />
        <Route path="/ordem/insumos" element={isAuthenticated ? <InsumosOrdemProducao /> : <Navigate to="/loginPage" />} />
          
        </Routes>
      </Router>

      {/* Renderização oculta para evitar warning de unused import */}
      <div style={{ display: 'none' }}>
        <Funcionalidades />
      </div>
    </div>
  );

 
};

export default App;
